import { NotificationType, useTranslation } from "@next-platform/client-common-core";
import clientClipboard from "@next-platform/client-common-core/services/clipboard";
import { useCallback } from "react";

import useToast from "@/hooks/useToast";

export default function useCopyMediaFilePreviewLink(pageHref: string) {
  const { t } = useTranslation();
  const { displayToast } = useToast();

  return useCallback(() => {
    const pageUrl = `${window.location.origin}${pageHref}`;
    clientClipboard
      .writeText(pageUrl)
      .then(() => displayToast({ message: t("gallery:mediaFilePreview.linkCopied"), type: NotificationType.success }))
      .catch(() => displayToast({ message: t("gallery:mediaFilePreview.copyLinkFailed"), type: NotificationType.error }));
  }, [displayToast, pageHref, t]);
}
